export enum EModules {
    "LOGISTICS" = "Logistics",
    "VENDORS" = "Vendors",
    "ADMIN" = "Admin",
    "SETTINGS" = "Settings",
    "PROJECTS" = "Projects",
    "ACCOUNTS" = "Accounts",
    "INSTALLATION"="INSTALLATION",
    "EVAPPLICATION"="EVAPPLICATION",
    "SURVEY"="SURVEY",
    "DEMOLITION" ="DEMOLITION",
    "STATIONS"="STATIONS",
    "FINANCE"="Finance",
    "COMPLAINTS"="COMPLAINTS",
    "PROGRAMS"="Programs",
    "PURCHASE_ORDERS"="PURCHASE_ORDERS",
}

export enum EAccountRole {
    BUYER = "Buyer",
    CPO = "CPO",
    HOST = "Host",
    INVESTOR = "Investor",
    BRANDING_PARTNER = "Branding Partner",
    DEALER = "Dealer",
}